export default __webpack_public_path__ + "static/media/ios.a019534c.png";